import PropTypes from 'prop-types'

import { iso8601PropType } from '../common/iso-8601-prop-type'
import { checklistItemPropType } from './checklist-item-prop-type'

/**
 * @typedef {Object} Checklist
 * @property {number} id - Id of the checklist.
 * @property {number} version - The number representing the version of the checklist.
 * @property {number} name - The name of the checklist.
 * @property {Object} type - The type of the checklist
 * @property {number} type.id - Id of the type of checklist.
 * @property {number} type.stringCode - The string code to translate the type of the checklist.
 * @property {string} type.name - The name of the type of checklist.
 * @property {number} accountId - The accountId of the account the checklist belongs to.
 * @property {Array.<ChecklistItem>} items - The checklist items.
 * @property {iso8601DateTimeSting} lastModificationTime - The last modification time for the checklist
 *     in ISO8601 UTC format.
 */
export const checklistPropType = PropTypes.shape({
    accountId: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(checklistItemPropType).isRequired,
    lastModificationTime: iso8601PropType.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        stringCode: PropTypes.string
    }).isRequired,
    version: PropTypes.number.isRequired
})
